import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, AlertTriangle } from 'lucide-react';
import { Button } from '../../components/ui/button';

const BloqueoSuspensionPage = () => {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-300">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Link to="/">
          <Button variant="ghost" className="mb-6 text-zinc-400 hover:text-white">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Volver
          </Button>
        </Link>

        <h1 className="text-3xl font-bold text-white mb-2">Cláusula de Bloqueo y Suspensión de Cuenta</h1>
        <p className="text-sm text-zinc-500 mb-8">Última actualización: 19 de febrero de 2026</p>

        <div className="prose prose-invert prose-zinc max-w-none space-y-8">
          
          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              Motivos de Bloqueo
            </h2>
            <p>
              La cuenta de un usuario podrá ser bloqueada temporal o definitivamente en los siguientes supuestos:
            </p>
            <div className="mt-4 space-y-3">
              <div className="flex items-start gap-3 p-4 bg-red-900/20 border border-red-800/30 rounded-lg">
                <AlertTriangle className="h-5 w-5 text-red-400 flex-shrink-0 mt-0.5" />
                <p className="text-sm">Impago de la suscripción o de cantidades debidas.</p>
              </div>
              <div className="flex items-start gap-3 p-4 bg-red-900/20 border border-red-800/30 rounded-lg">
                <AlertTriangle className="h-5 w-5 text-red-400 flex-shrink-0 mt-0.5" />
                <p className="text-sm">Manipulación deliberada de métricas (peso, porcentaje corporal, rendimiento, adherencia, etc.).</p>
              </div>
              <div className="flex items-start gap-3 p-4 bg-red-900/20 border border-red-800/30 rounded-lg">
                <AlertTriangle className="h-5 w-5 text-red-400 flex-shrink-0 mt-0.5" />
                <p className="text-sm">Conducta inapropiada, incluyendo acoso, insultos o difusión de contenido ofensivo.</p>
              </div>
              <div className="flex items-start gap-3 p-4 bg-red-900/20 border border-red-800/30 rounded-lg">
                <AlertTriangle className="h-5 w-5 text-red-400 flex-shrink-0 mt-0.5" />
                <p className="text-sm">Suplantación de identidad o intento de acceso a cuentas de terceros.</p>
              </div>
              <div className="flex items-start gap-3 p-4 bg-red-900/20 border border-red-800/30 rounded-lg">
                <AlertTriangle className="h-5 w-5 text-red-400 flex-shrink-0 mt-0.5" />
                <p className="text-sm">Uso fraudulento de la plataforma, incluido el uso de múltiples cuentas para obtener ventajas indebidas.</p>
              </div>
              <div className="flex items-start gap-3 p-4 bg-red-900/20 border border-red-800/30 rounded-lg">
                <AlertTriangle className="h-5 w-5 text-red-400 flex-shrink-0 mt-0.5" />
                <p className="text-sm">Incumplimiento grave o reiterado de los términos y condiciones.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              Durante el Bloqueo
            </h2>
            <ul className="list-disc pl-6 space-y-3 mt-4">
              <li>El acceso del usuario a la plataforma quedará suspendido.</li>
              <li>Los datos no se borrarán inmediatamente, sino que se conservarán durante los plazos de prescripción y obligaciones legales aplicables.</li>
              <li>El usuario podrá solicitar la exportación de sus datos personales y, en la medida técnicamente posible, de sus registros de actividad, mediante solicitud por escrito al correo de contacto.</li>
              <li>La posible reactivación de la cuenta se valorará caso por caso por el responsable.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              Contacto para Solicitudes
            </h2>
            <div className="p-4 bg-zinc-900/50 rounded-lg">
              <p className="text-sm">
                Para cualquier solicitud relacionada con el bloqueo de cuenta, exportación de datos o reactivación, 
                el usuario puede contactar a través del correo electrónico:
              </p>
              <p className="text-primary font-semibold mt-2">jagubon@icloud.com</p>
            </div>
          </section>

        </div>

        <div className="mt-12 pt-8 border-t border-zinc-800">
          <p className="text-sm text-zinc-500 text-center">
            © 2026 GUARDIÁNSFIT - Todos los derechos reservados
          </p>
        </div>
      </div>
    </div>
  );
};

export default BloqueoSuspensionPage;
